import React from 'react'
import Planning2 from '../img/Planning/Planning 2.jpg';
import Planning3 from '../img/Planning/Planning 3.jpg';
import Planning5 from '../img/Planning/Planning 5.jpg';
import Planning6 from '../img/Planning/Planning 6.jpg';
import Planning8 from '../img/Planning/Planning 8.jpg';
import Planning4 from '../img/Planning/Planning 4.jpg';
import Planning9 from '../img/Planning/Planning 9.jpg';
import Planning10 from '../img/Planning/Planning 10.jpg';
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {AnimationOnScroll} from 'react-animation-on-scroll'


function Planning() {
  const location = useLocation();
    const componentRef = useRef(null);

    useEffect(() => {
        if (componentRef.current) {
            setTimeout(() => {

                componentRef.current.scrollIntoView({ behavior: "smooth" });
            }, 3000);
        }
    }, [location])
  return (
    
    <section ref={componentRef}>
      <div className="about">
            <h2 id="Content">Planning</h2>
        </div>
        <div className="DispalyingImage">
            <AnimationOnScroll animateIn='slipeLeft'><img src={Planning2} alt="" className="DisImg"/></AnimationOnScroll>
            <AnimationOnScroll animateIn='slipeLeft'><img src={Planning3} alt="" className="DisImg"/></AnimationOnScroll>
            <AnimationOnScroll animateIn='slipeLeft'><img src={Planning5} alt="" className="DisImg"/></AnimationOnScroll>
            <AnimationOnScroll animateIn='slipeLeft'><img src={Planning6} alt="" className="DisImg"/></AnimationOnScroll>
            <AnimationOnScroll animateIn='slipeLeft'><img src={Planning8} alt="" className="DisImg"/></AnimationOnScroll>
            <AnimationOnScroll animateIn='slipeLeft'><img src={Planning4} alt="" className="DisImg"/></AnimationOnScroll>
            <AnimationOnScroll animateIn='slipeLeft'><img src={Planning9} alt="" className="DisImg"/></AnimationOnScroll>
            <AnimationOnScroll animateIn='slipeLeft'><img src={Planning10} alt="" className="DisImg"/></AnimationOnScroll>
        </div>
    </section>
  )
}

export default Planning
